<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">
            {{ isView ? "View " : $route.params.id ? "Edit " : "Add " }} Class
          </h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <fieldset :disabled="isView">
      <form @submit.prevent="save">
        <!-- Class Details -->
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header text-center pb-0">
                <h3>Class Details</h3>
              </div>
              <div class="card-body">
                <!-- School -->
                <div
                  class="form-row"
                  v-if="tokenObj.UserType == userTypeMainAdmin"
                >
                  <div class="form-group col-md-6">
                    <label>School<span class="text-danger">*</span></label>
                    <select
                      class="form-control"
                      v-model="schoolId"
                      required
                      @change="onChangeSchool($event)"
                    >
                      <option value>-- Please Select School --</option>
                      <option
                        v-for="item in schools"
                        :value="item.Id"
                        :key="item.Id"
                      >
                        {{ item.Name }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- /School -->

                <!-- Class and Duration -->
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Class<span class="text-danger">*</span></label>
                    <div class="form-row">
                      <div class="col-md-6">
                        <select
                          v-model="subjectId"
                          class="form-control"
                          required
                        >
                          <option value>
                            -- Please Select Class Subject --
                          </option>
                          <option
                            v-for="item in subjects"
                            :value="item.Id"
                            :key="item.Id"
                          >
                            {{ item.Name }}
                          </option>
                        </select>
                      </div>
                      <div class="col-md-6 mt-2 mt-md-0 mt-lg-0">
                        <select
                          v-model="subjectLevelId"
                          class="form-control"
                          required
                          @change="onChangeSubjectLevel($event)"
                        >
                          <option value>
                            -- Please Select Subject Level --
                          </option>
                          <option
                            v-for="item in subjectLevels"
                            :value="item.Id"
                            :key="item.Id"
                          >
                            {{ item.Name }}
                          </option>
                        </select>
                        <input
                          type="text"
                          v-model="subjectLevelOthers"
                          class="form-control mt-1"
                          required
                          maxlength="100"
                          placeholder="Input Other Subject Level Here"
                          v-if="showSubjectLevelOthers"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>
                      Duration (h/m)<span class="text-danger">*</span>
                    </label>
                    <div class="form-row">
                      <div class="col-md-6">
                        <select
                          class="form-control"
                          v-model="durationHour"
                          :required="!durationMinute || durationMinute == 0"
                        >
                          <option value>-- Please Select Hours --</option>
                          <option
                            v-for="item in hours"
                            :value="item"
                            :key="item"
                          >
                            {{ item }}
                          </option>
                        </select>
                      </div>
                      <div class="col-md-6 mt-2 mt-md-0 mt-lg-0">
                        <select
                          class="form-control"
                          v-model="durationMinute"
                          :required="!durationHour || durationHour == 0"
                        >
                          <option value>-- Please Select Minutes --</option>
                          <option
                            v-for="item in minutes"
                            :value="item"
                            :key="item"
                          >
                            {{ item }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /Class and Duration -->

                <!-- Class Fee -->
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label class="mr-5">
                      Class Fee<span class="text-danger">*</span>
                    </label>
                    <template v-if="schoolSalesTax.IsSalesTaxRegistered">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="chkInclusiveTax"
                        v-model="isInclusiveTax"
                      />
                      <label class="form-check-label" for="chkInclusiveTax">
                        Inclusive of Sales Tax
                      </label>
                    </template>
                    <div class="form-row">
                      <div class="col-md-6">
                        <select
                          class="form-control"
                          v-model="currencyId"
                          required
                        >
                          <option value>-- Please Select Currency --</option>
                          <option
                            v-for="item in currencies"
                            :value="item.Id"
                            :key="item.Id"
                          >
                            {{ item.Name }}
                          </option>
                        </select>
                      </div>
                      <div class="col-md-6 mt-2 mt-md-0 mt-lg-0">
                        <input
                          type="number"
                          v-model="amount"
                          class="form-control"
                          min="1"
                          max="999999999"
                          step="0.01"
                          placeholder="Input Amount"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Class Fee</label>
                    <div v-html="feeAmountDisplay"></div>
                  </div>
                </div>
                <!-- /Class Fee -->
              </div>
            </div>
          </div>
        </div>
        <!-- /Class Details -->

        <!-- Class Schedule -->
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header text-center pb-0">
                <h3>Class Schedule</h3>
              </div>
              <div class="card-body">
                <!-- Class Frequency -->
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>
                      Class Frequency<span class="text-danger">*</span>
                    </label>
                    <select
                      class="form-control"
                      v-model="frequencyId"
                      required
                      @change="onChangeFrequency($event)"
                    >
                      <option value>-- Please Select Class Frequency --</option>
                      <option
                        v-for="item in frequencies"
                        :value="item.Id"
                        :key="item.Id"
                      >
                        {{ item.Frequency }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group col-md-6" v-if="showCustomFrequency">
                    <label>
                      Custom Frequency<span class="text-danger">*</span>
                    </label>
                    <select
                      class="form-control"
                      v-model="customFrequency"
                      required
                    >
                      <option value>-- Please Select Frequency --</option>
                      <option value="Daily">Daily</option>
                      <option value="Weekly">Weekly</option>
                      <option value="Monthly">Monthly</option>
                      <option value="Yearly">Yearly</option>
                    </select>
                  </div>
                </div>
                <div class="form-row" v-if="showCustomFrequency">
                  <template v-if="customFrequency == 'Daily'">
                    <div class="form-group col-md-6 d-flex">
                      <span class="mt-2 mr-2">Every</span>
                      <input
                        type="number"
                        v-model="customDailyFrequencyEvery"
                        class="form-control customdaily-input"
                        min="1"
                        max="365"
                        step="1"
                        required
                      />
                      <span class="mt-2 ml-2">day(s)</span>
                    </div>
                  </template>
                  <template v-if="customFrequency == 'Weekly'">
                    <div class="form-group col-md-4 d-flex fit-content">
                      <span class="mt-2 mr-2">Every</span>
                      <input
                        type="number"
                        v-model="customWeeklyFrequencyEvery"
                        class="form-control customweekly-input"
                        min="1"
                        max="999"
                        step="1"
                        required
                      />
                      <span class="mt-2 ml-2">week(s) on:</span>
                    </div>
                    <div class="form-group col-md-8 custtomweekly-div">
                      <div class="week_options">
                        <input
                          type="checkbox"
                          id="chkSunday"
                          name="week"
                          value="Sunday"
                          v-model="customWeeklyFrequencyOn"
                        />
                        <input
                          type="checkbox"
                          id="chkMonday"
                          name="week"
                          value="Monday"
                          v-model="customWeeklyFrequencyOn"
                        />
                        <input
                          type="checkbox"
                          id="chkTuesday"
                          name="week"
                          value="Tuesday"
                          v-model="customWeeklyFrequencyOn"
                        />
                        <input
                          type="checkbox"
                          id="chkWednesday"
                          name="week"
                          value="Wednesday"
                          v-model="customWeeklyFrequencyOn"
                        />
                        <input
                          type="checkbox"
                          id="chkThursday"
                          name="week"
                          value="Thursday"
                          v-model="customWeeklyFrequencyOn"
                        />
                        <input
                          type="checkbox"
                          id="chkFriday"
                          name="week"
                          value="Friday"
                          v-model="customWeeklyFrequencyOn"
                        />
                        <input
                          type="checkbox"
                          id="chkSaturday"
                          name="week"
                          value="Saturday"
                          v-model="customWeeklyFrequencyOn"
                        />
                      </div>
                      <label
                        for="chkSunday"
                        :class="
                          customWeeklyFrequencyOn.includes('Sunday')
                            ? 'bg-grey'
                            : ''
                        "
                      >
                        S
                      </label>
                      <label
                        for="chkMonday"
                        :class="
                          customWeeklyFrequencyOn.includes('Monday')
                            ? 'bg-grey'
                            : ''
                        "
                      >
                        M
                      </label>
                      <label
                        for="chkTuesday"
                        :class="
                          customWeeklyFrequencyOn.includes('Tuesday')
                            ? 'bg-grey'
                            : ''
                        "
                      >
                        T
                      </label>
                      <label
                        for="chkWednesday"
                        :class="
                          customWeeklyFrequencyOn.includes('Wednesday')
                            ? 'bg-grey'
                            : ''
                        "
                      >
                        W
                      </label>
                      <label
                        for="chkThursday"
                        :class="
                          customWeeklyFrequencyOn.includes('Thursday')
                            ? 'bg-grey'
                            : ''
                        "
                      >
                        T
                      </label>
                      <label
                        for="chkFriday"
                        :class="
                          customWeeklyFrequencyOn.includes('Friday')
                            ? 'bg-grey'
                            : ''
                        "
                      >
                        F
                      </label>
                      <label
                        for="chkSaturday"
                        :class="
                          customWeeklyFrequencyOn.includes('Saturday')
                            ? 'bg-grey'
                            : ''
                        "
                      >
                        S
                      </label>
                    </div>
                  </template>
                  <template v-if="customFrequency == 'Monthly'">
                    <div
                      class="form-group col-md-4 d-flex fit-content mr-md-3 mr-lg-3"
                    >
                      <span class="mt-2 mr-2">Every</span>
                      <input
                        type="number"
                        v-model="customMonthlyFrequencyEvery"
                        class="form-control custommonthly-input"
                        min="1"
                        max="12"
                        step="1"
                        required
                      />
                      <span class="mt-2 ml-2">month(s)</span>
                    </div>
                    <div
                      class="form-group col-md-4 custommonthly-div d-flex fit-content mr-md-3 mr-lg-3"
                    >
                      <input
                        type="radio"
                        id="customMonthlyFrequencyEach"
                        name="customMonthlyFrequencyType"
                        value="each"
                        v-model="customMonthlyFrequencyType"
                        class="mr-1"
                        style="height: 37px"
                      />
                      <label for="customMonthlyFrequencyEach" class="mt-2 mr-2">
                        Each
                      </label>
                      <div class="month_options">
                        <input
                          v-for="i in 31"
                          :key="i"
                          type="checkbox"
                          :id="'customMonthlyFrequencyDay' + i"
                          name="customMonthlyFrequencyDay"
                          :value="i"
                          v-model="customMonthlyFrequencyEach"
                          :disabled="customMonthlyFrequencyType == 'on'"
                        />
                      </div>
                      <div class="custommonthly-cal">
                        <template v-for="i in 31">
                          <label
                            :key="i"
                            :for="'customMonthlyFrequencyDay' + i"
                            :class="
                              customMonthlyFrequencyEach.includes(i)
                                ? 'bg-grey'
                                : ''
                            "
                          >
                            {{ i }}
                          </label>
                          <br :key="'br' + i" v-if="i % 7 == 0" />
                        </template>
                      </div>
                    </div>
                    <div
                      class="form-group col-md-4 custommonthly-div-on d-flex"
                    >
                      <input
                        type="radio"
                        id="customMonthlyFrequencyOn"
                        name="customMonthlyFrequencyType"
                        value="on"
                        v-model="customMonthlyFrequencyType"
                        class="mr-1"
                        style="height: 37px"
                      />
                      <label
                        for="customMonthlyFrequencyOn"
                        class="mt-2 mr-2"
                        style="max-width: fit-content"
                      >
                        On the
                      </label>
                      <select
                        class="form-control mr-2"
                        v-model="customMonthlyFrequencyOnOrder"
                        required
                        style="max-width: fit-content"
                        :disabled="customMonthlyFrequencyType == 'each'"
                      >
                        <option value="first">first</option>
                        <option value="second">second</option>
                        <option value="third">third</option>
                        <option value="fourth">fourth</option>
                        <option value="fifth">fifth</option>
                        <option disabled>─────</option>
                        <option value="last">last</option>
                      </select>
                      <select
                        class="form-control"
                        v-model="customMonthlyFrequencyOnPeriod"
                        required
                        style="max-width: fit-content"
                        :disabled="customMonthlyFrequencyType == 'each'"
                      >
                        <option value="Sunday">Sunday</option>
                        <option value="Monday">Monday</option>
                        <option value="Tuesday">Tuesday</option>
                        <option value="Wednesday">Wednesday</option>
                        <option value="Thursday">Thursday</option>
                        <option value="Friday">Friday</option>
                        <option value="Saturday">Saturday</option>
                        <option disabled>─────────</option>
                        <option value="day">day</option>
                        <option value="weekday">weekday</option>
                        <option value="weekend day">weekend day</option>
                      </select>
                    </div>
                  </template>
                  <template v-if="customFrequency == 'Yearly'">
                    <div class="form-group col-md-4 d-flex fit-content">
                      <span class="mt-2 mr-2">Every</span>
                      <input
                        type="number"
                        v-model="customYearlyFrequencyEvery"
                        class="form-control customyearly-input"
                        min="1"
                        max="100"
                        step="1"
                        required
                      />
                      <span class="mt-2 ml-2">year(s) in:</span>
                    </div>
                    <div
                      class="form-group col-md-3 customyearly-div fit-content mr-md-3 mr-lg-3"
                    >
                      <div class="year_options">
                        <input
                          v-for="i in 12"
                          :key="i"
                          type="checkbox"
                          :id="'customYearlyFrequencyMonth' + i"
                          name="customYearlyFrequencyMonth"
                          :value="years[i - 1]"
                          v-model="customYearlyFrequencyIn"
                        />
                      </div>
                      <div class="customyearly-cal">
                        <template v-for="i in 12">
                          <label
                            :key="i"
                            :for="'customYearlyFrequencyMonth' + i"
                            :class="
                              customYearlyFrequencyIn.includes(years[i - 1])
                                ? 'bg-grey'
                                : ''
                            "
                          >
                            {{ years[i - 1] }}
                          </label>
                          <br :key="'br' + i" v-if="i % 4 == 0" />
                        </template>
                      </div>
                    </div>
                    <div class="form-group col-md-5 customyearly-div-on d-flex">
                      <input
                        type="checkbox"
                        id="customYearlyFrequencyOn"
                        v-model="isCustomYearlyFrequencyOn"
                        class="mr-1"
                        style="height: 37px"
                      />
                      <label
                        for="customYearlyFrequencyOn"
                        class="mt-2 mr-2"
                        style="max-width: fit-content"
                      >
                        On the:
                      </label>
                      <select
                        class="form-control mr-2"
                        v-model="customYearlyFrequencyOnOrder"
                        required
                        style="max-width: fit-content"
                        :disabled="!isCustomYearlyFrequencyOn"
                      >
                        <option value="first">first</option>
                        <option value="second">second</option>
                        <option value="third">third</option>
                        <option value="fourth">fourth</option>
                        <option value="fifth">fifth</option>
                        <option disabled>─────</option>
                        <option value="last">last</option>
                      </select>
                      <select
                        class="form-control"
                        v-model="customYearlyFrequencyOnPeriod"
                        required
                        style="max-width: fit-content"
                        :disabled="!isCustomYearlyFrequencyOn"
                      >
                        <option value="Sunday">Sunday</option>
                        <option value="Monday">Monday</option>
                        <option value="Tuesday">Tuesday</option>
                        <option value="Wednesday">Wednesday</option>
                        <option value="Thursday">Thursday</option>
                        <option value="Friday">Friday</option>
                        <option value="Saturday">Saturday</option>
                        <option disabled>─────────</option>
                        <option value="day">day</option>
                        <option value="weekday">weekday</option>
                        <option value="weekend day">weekend day</option>
                      </select>
                    </div>
                  </template>
                </div>
                <!-- /Class Frequency -->

                <!-- Commencement Date -->
                <div class="form-row" v-if="!isStudent">
                  <div class="form-group col-md-6">
                    <label>
                      Commencement Date<span class="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      v-model="commencementDate"
                      class="form-control"
                      required
                    />
                  </div>
                </div>
                <!-- /Commencement Date -->

                <!-- Class Time -->
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label>Class Time<span class="text-danger">*</span></label>
                    <div class="table-responsive">
                      <table class="table table-bordered">
                        <thead class="thead-light">
                          <tr>
                            <th class="no-col">#</th>
                            <th class="timezone-col">Time Zone</th>
                            <th class="time-col">Time</th>
                            <th class="capacity-col">Capacity</th>
                            <th class="action-col" v-if="!$route.params.id">
                              <button
                                type="button"
                                class="btn btn-primary"
                                @click="addClassTime"
                              >
                                <i
                                  class="fa fa-plus"
                                  title="Add Class Time"
                                ></i>
                              </button>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(timing, i) in timings" :key="i">
                            <td class="no-col">{{ i + 1 }}</td>
                            <td class="timezone-col">
                              <select
                                v-model="timing.TimezoneId"
                                class="form-control form-control-sm"
                                required
                              >
                                <option value>
                                  -- Please Select Time Zone --
                                </option>
                                <option
                                  v-for="item in timezones"
                                  :value="item.Id"
                                  :key="item.Id"
                                >
                                  {{ item.Name }}
                                </option>
                              </select>
                            </td>
                            <td class="time-col">
                              <div class="d-flex">
                                <select
                                  v-model="timing.Hour"
                                  class="form-control form-control-sm fit-content"
                                  required
                                >
                                  <option value>0</option>
                                  <option
                                    v-for="item in timingHours"
                                    :value="item"
                                    :key="item"
                                  >
                                    {{ item }}
                                  </option>
                                </select>
                                <span class="mx-2">:</span>
                                <select
                                  v-model="timing.Minute"
                                  class="form-control form-control-sm fit-content"
                                >
                                  <option
                                    v-for="item in timingMinutes"
                                    :value="item"
                                    :key="item"
                                  >
                                    {{ item }}
                                  </option>
                                </select>
                                <select
                                  v-model="timing.TimePart"
                                  class="form-control form-control-sm ml-2 fit-content"
                                  required
                                >
                                  <option value="AM">AM</option>
                                  <option value="PM">PM</option>
                                </select>
                              </div>
                            </td>
                            <td class="capacity-col">
                              <input
                                type="number"
                                v-model="timing.Capacity"
                                class="form-control form-control-sm"
                                placeholder="Input Class Capacity"
                                step="1"
                                min="1"
                                max="999999"
                                required
                              />
                            </td>
                            <td class="action-col" v-if="!$route.params.id">
                              <button
                                type="button"
                                class="btn btn-danger"
                                @click="removeClassTime(i)"
                              >
                                <i
                                  class="fa fa-trash-o"
                                  title="Remove Class Time"
                                ></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <!-- /Class Time -->

                <!-- Class Location -->
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label>Class Location</label>
                    <div class="form-row">
                      <div class="col-md-3">
                        <select
                          class="form-control"
                          v-model="locationId"
                          @change="onChangeLocation($event)"
                        >
                          <option value>-- Please Select Location --</option>
                          <option
                            v-for="item in locations"
                            :value="item.Id"
                            :key="item.Id"
                          >
                            {{ item.Location }}
                          </option>
                        </select>
                      </div>
                      <div
                        class="col-md-9 mt-2 mt-md-0 mt-lg-0"
                        v-if="showLocationSchoolAddress"
                      >
                        <div class="table-responsive">
                          <table class="table table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th>
                                  <input
                                    type="checkbox"
                                    v-model="checkAllSchoolAddresses"
                                    @change="
                                      onChangeCheckAllSchoolAddresses($event)
                                    "
                                  />
                                </th>
                                <th>Type</th>
                                <th>Street 1</th>
                                <th>Street 2</th>
                                <th>City</th>
                                <th>Postcode</th>
                                <th>Country</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(address, i) in schoolAddresses"
                                :key="i"
                              >
                                <td>
                                  <input
                                    type="checkbox"
                                    v-model="address.IsSelected"
                                    @change="onChangeCheckSchoolAddress"
                                  />
                                </td>
                                <td>{{ address.AddressTypeName }}</td>
                                <td>{{ address.Street1 }}</td>
                                <td>{{ address.Street2 }}</td>
                                <td>{{ address.City }}</td>
                                <td>{{ address.Postcode }}</td>
                                <td>{{ address.CountryName }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div
                        class="col-md-6 mt-2 mt-md-0 mt-lg-0"
                        v-if="showLocationOthers"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="locationOthers"
                          maxlength="200"
                          required
                          placeholder="Input Other Location Here"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /Class Location -->
              </div>
            </div>
          </div>
        </div>
        <!-- /Class Schedule -->

        <!-- Instructors -->
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header text-center pb-0">
                <h3>Instructors</h3>
              </div>
              <div class="card-body">
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <div class="table-responsive">
                      <table class="table instructor-table">
                        <thead class="thead-light">
                          <tr>
                            <th>
                              <div class="d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  v-model="checkAllInstructors"
                                  @change="onChangeCheckAllInstructors($event)"
                                />
                                <label class="mt-2 ml-2">All Instructors</label>
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(instructor, i) in instructors" :key="i">
                            <td>
                              <div class="d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  v-model="instructor.IsSelected"
                                  :id="instructor.Id"
                                  @change="onChangeCheckInstructor"
                                />
                                <label :for="instructor.Id" class="mt-2 ml-2">
                                  {{
                                    instructor.Name +
                                    " (" +
                                    instructor.UserName +
                                    ")"
                                  }}
                                </label>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Instructors -->

        <!-- Remarks -->
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header text-center pb-0">
                <h3>Remarks</h3>
              </div>
              <div class="card-body">
                <textarea
                  v-model="remarks"
                  placeholder="Input Remarks Here"
                  class="form-control"
                  maxlength="1000"
                >
                </textarea>
              </div>
            </div>
          </div>
        </div>
        <!-- /Remarks -->

        <!-- Button -->
        <div class="text-center" v-if="!isView">
          <router-link
            class="btn btn-danger mr-4"
            :to="{
              name:
                tokenObj.UserType == userTypeMainAdmin
                  ? 'mainAdminClassList'
                  : 'schoolAdminClassList',
            }"
          >
            Cancel
          </router-link>
          <button class="btn btn-primary" type="submit">
            {{ $route.params.id ? "Update " : "Add " }}
          </button>
        </div>
        <!-- /Button -->
      </form>
    </fieldset>
    <!-- Button Back -->
    <div class="text-center" v-if="isView">
      <router-link
        class="btn btn-primary mr-4 w-xs-50"
        :to="{ name: classListRouter }"
      >
        <i class="fa fa-reply mr-2"></i>Back to List of Classes
      </router-link>
      <button class="btn btn-success w-xs-40" @click="addClassBooking">
        Add Class Booking
      </button>
    </div>
    <!-- /Button Back -->
  </div>
</template>

<script>
import axios from "axios";
import API from "../../../http-common.js";
import config from "../../../config.js";
export default {
  data() {
    return {
      userTypeMainAdmin: config.USERTYPE_MAIN_ADMIN,
      userTypeSchoolAdmin: config.USERTYPE_SCHOOL_ADMIN,
      userTypeInstructor: config.USERTYPE_INSTRUCTOR,
      userTypeInstructorSchoolAdmin:
        config.USERTYPE_INSTRUCTOR_AND_SCHOOL_ADMIN,
      userTypeStudent: config.USERTYPE_STUDENT,
      defaultCurrency: config.DEFAULT_CURRENCY,
      schoolId: "",
      schools: [],
      subjectId: "",
      subjects: [],
      subjectLevelId: "",
      subjectLevels: [],
      subjectLevelOthers: "",
      showSubjectLevelOthers: false,
      durationHour: "",
      durationMinute: "",
      isInclusiveTax: false,
      currencyId: "",
      currencies: [],
      amount: "",
      schoolSalesTax: {
        IsSalesTaxRegistered: false,
        SalesTax: "",
        SalesTaxPercentage: 0,
      },
      frequencyId: "",
      frequencies: [],
      showCustomFrequency: false,
      customFrequency: "",
      customDailyFrequencyEvery: 1,

      customWeeklyFrequencyEvery: 1,
      customWeeklyFrequencyOn: [],

      customMonthlyFrequencyEvery: 1,
      customMonthlyFrequencyType: "each",
      customMonthlyFrequencyEach: [],
      customMonthlyFrequencyOnOrder: "first",
      customMonthlyFrequencyOnPeriod: "day",

      customYearlyFrequencyEvery: 1,
      years: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
      ],
      customYearlyFrequencyIn: [],
      isCustomYearlyFrequencyOn: true,
      customYearlyFrequencyOnOrder: "first",
      customYearlyFrequencyOnPeriod: "day",

      commencementDate: "",
      timings: [
        {
          TimezoneId: "",
          Hour: "",
          Minute: "00",
          TimePart: "AM",
          Capacity: null,
        },
      ],
      timezones: [],
      defaultTimezoneId: "",
      locationId: "",
      locations: [],
      showLocationOthers: false,
      showLocationSchoolAddress: false,
      schoolAddresses: [],
      checkAllSchoolAddresses: false,
      locationOthers: "",
      instructors: [],
      checkAllInstructors: false,
      remarks: "",
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
    isView() {
      return this.$route.path.includes("/show");
    },
    hours() {
      let hours = [];
      for (let i = 0; i <= 24; i++) {
        hours.push(i);
      }
      return hours;
    },
    minutes() {
      let minutes = [];
      for (let i = 0; i <= 59; i++) {
        minutes.push(i);
      }
      return minutes;
    },
    feeAmountDisplay() {
      if (!this.schoolId) return "";
      const options = { style: "decimal", minimumFractionDigits: 2 };
      let amount = parseFloat(this.amount ? this.amount : 0);
      let currencyRec = this.currencies.find((c) => c.Id == this.currencyId);
      let currency = currencyRec ? currencyRec.ShortForm : "";
      let output = "";
      if (this.schoolSalesTax.IsSalesTaxRegistered) {
        if (this.isInclusiveTax) {
          output = `<b>Amount Due (inclusive of ${
            this.schoolSalesTax.SalesTax
          } at ${
            this.schoolSalesTax.SalesTaxPercentage
          }%) = ${currency} ${amount.toLocaleString("en-US", options)}</b>`;
        } else {
          let taxAmount =
            (this.schoolSalesTax.SalesTaxPercentage * amount) / 100;
          let amountAfterTax = amount + taxAmount;
          output = `${currency} ${amount.toLocaleString(
            "en-US",
            options
          )} <br/> Add ${this.schoolSalesTax.SalesTax} at ${
            this.schoolSalesTax.SalesTaxPercentage
          }% = ${currency} ${taxAmount.toLocaleString(
            "en-US",
            options
          )} <br/> <b>Amount Due = ${currency} ${amountAfterTax.toLocaleString(
            "en-US",
            options
          )}</b>`;
        }
      } else {
        output = `<b>Amount Due = ${currency} ${amount.toLocaleString(
          "en-US",
          options
        )}</b>`;
      }
      return output;
    },
    timingHours() {
      let hours = [];
      for (let i = 1; i <= 12; i++) {
        // hours.push(i.toString().padStart(2, "0"));
        hours.push(i);
      }
      return hours;
    },
    timingMinutes() {
      let minutes = [];
      for (let i = 0; i <= 59; i++) {
        minutes.push(i.toString().padStart(2, "0"));
      }
      return minutes;
    },
    isInstructor() {
      return (
        (this.tokenObj.UserType == this.userTypeInstructorSchoolAdmin ||
          this.tokenObj.UserType == this.userTypeInstructor) &&
        this.$route.path.includes("/instructor/") &&
        !this.$route.path.includes("/schooladmin/")
      );
    },
    isStudent() {
      return (
        this.tokenObj.UserType == this.userTypeStudent &&
        this.$route.path.includes("/student/")
      );
    },
    classListRouter() {
      let router = "";
      if (this.isInstructor) {
        router = "instructorMyAssignedClass";
      } else if (this.isStudent) {
        router = "studentClassAvailability";
      } else {
        router =
          this.tokenObj.UserType == this.userTypeMainAdmin
            ? "mainAdminClassList"
            : "schoolAdminClassList";
      }
      return router;
    },
  },
  methods: {
    //school
    getSchools() {
      API.school
        .getSchools({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.schools = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeSchool(event) {
      this.subjectId = "";
      this.subjectLevelId = "";
      this.showSubjectLevelOthers = false;
      this.subjectLevelOthers = null;
      this.checkAllSchoolAddresses = false;
      this.checkAllInstructors = false;
      let schoolId = event.target.value;
      if (schoolId) {
        this.getSubjectsForClass(schoolId);
        this.getSubjectLevelsForClass(schoolId);
        this.getSchoolSalesTax(schoolId);
        this.getSchoolAddresses(schoolId);
        this.getSchoolInstructors(schoolId);
      } else {
        this.subjects = [];
        this.subjectLevels = [];
        this.schoolAddresses = [];
        this.instructors = [];
      }
    },
    //class
    getSubjectsForClass(schoolId) {
      API.subject
        .getSubjectsForClass({
          Token: this.tokenObj.Token,
          SchoolId: schoolId,
        })
        .then((response) => {
          if (response.data.success) {
            this.subjects = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getSubjectLevelsForClass(schoolId) {
      API.class
        .getSubjectLevelsForClass({
          Token: this.tokenObj.Token,
          SchoolId: schoolId,
        })
        .then((response) => {
          if (response.data.success) {
            this.subjectLevels = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeSubjectLevel(event) {
      let subjectLevelId = event.target.value;
      let subjectLevel = this.subjectLevels.find((c) => c.Id == subjectLevelId);
      this.showSubjectLevelOthers =
        subjectLevel && subjectLevel.Name == "Others";
    },
    //class fee
    getCurrencies() {
      API.common
        .getCurrencies({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.currencies = response.data.data;
            if (!this.$route.params.id) {
              let currencyId = this.currencies.find(
                (c) => c.ShortForm == this.defaultCurrency
              ).Id;
              this.currencyId = currencyId;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getSchoolSalesTax(schoolId) {
      API.school
        .getSchoolSalesTax({
          Token: this.tokenObj.Token,
          SchoolId: schoolId,
        })
        .then((response) => {
          if (response.data.success) {
            this.schoolSalesTax = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //class frequency
    getClassFrequencies() {
      API.class
        .getClassFrequencies({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.frequencies = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeFrequency(event) {
      let frequencyId = event.target.value;
      let frequency = this.frequencies.find((c) => c.Id == frequencyId);
      this.showCustomFrequency = frequency && frequency.Frequency == "Custom";
    },
    getTimezones() {
      API.common
        .getTimezones({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.timezones = response.data.data;
            if (!this.$route.params.id) this.getGeolocation();
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getGeolocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.showPosition,
          this.showError,
          { timeout: 300000, maximumAge: 1800000 }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
      }
    },
    showPosition(position) {
      const { latitude, longitude } = position.coords;
      this.$store.state.isLoading = true;
      axios
        .get(
          `https://api.timezonedb.com/v2.1/get-time-zone?key=GS66VJW5BPIQ&format=json&by=position&lat=${latitude}&lng=${longitude}`
        )
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.status == 200) {
            let timezone = this.timezones.find(
              (c) => c.Name == response.data.zoneName
            );
            if (timezone) {
              this.timings[0].TimezoneId = timezone.Id;
              this.defaultTimezoneId = timezone.Id;
            }
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
    showError(error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          console.error("User denied the request for Geolocation.");
          break;
        case error.POSITION_UNAVAILABLE:
          console.error("Location information is unavailable.");
          break;
        case error.TIMEOUT:
          console.error("The request to get user location timed out.");
          break;
        case error.UNKNOWN_ERROR:
          console.error("An unknown error occurred.");
          break;
        default:
          console.error("An unknown error occurred.");
      }
    },
    //class time
    addClassTime() {
      this.timings.push({
        TimezoneId: this.defaultTimezoneId,
        Hour: "",
        Minute: "00",
        TimePart: "AM",
        Capacity: null,
      });
    },
    removeClassTime(index) {
      this.timings.splice(index, 1);
    },
    //class location
    getClassLocations() {
      API.class
        .getClassLocations({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.locations = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeLocation(event) {
      let locationId = event.target.value;
      let location = this.locations.find((c) => c.Id == locationId);
      this.showLocationOthers = location && location.Location == "Others";
      this.showLocationSchoolAddress =
        location && location.Location == "School Address";
    },
    getSchoolAddresses(schoolId) {
      API.school
        .getSchoolAddresses({ Token: this.tokenObj.Token, SchoolId: schoolId })
        .then((response) => {
          if (response.data.success) {
            this.schoolAddresses = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeCheckAllSchoolAddresses(event) {
      this.checkAllSchoolAddresses = event.target.checked;
      for (let address of this.schoolAddresses) {
        address.IsSelected = this.checkAllSchoolAddresses;
      }
    },
    onChangeCheckSchoolAddress() {
      let selectedAddresses = this.schoolAddresses.filter(
        (c) => c.IsSelected == true
      );
      this.checkAllSchoolAddresses =
        selectedAddresses.length == this.schoolAddresses.length;
    },
    //instructor
    getSchoolInstructors(schoolId) {
      API.school
        .getSchoolInstructors({
          Token: this.tokenObj.Token,
          SchoolId: schoolId,
        })
        .then((response) => {
          if (response.data.success) {
            this.instructors = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeCheckAllInstructors(event) {
      this.checkAllInstructors = event.target.checked;
      for (let instructor of this.instructors) {
        instructor.IsSelected = this.checkAllInstructors;
      }
    },
    onChangeCheckInstructor() {
      let selectedInstructors = this.instructors.filter(
        (c) => c.IsSelected == true
      );
      this.checkAllInstructors =
        selectedInstructors.length == this.instructors.length;
    },
    //action
    save() {
      //validation
      if (this.durationHour == 0 && this.durationMinute == 0) {
        this.$swal("Invalid duration. Hour and Minute cannot be both zero.", {
          icon: "error",
        });
        return;
      }
      if (this.timings.length == 0) {
        this.$swal("Please add at least 1 class time", { icon: "error" });
        return;
      }
      //check for duplicate timing
      for (let timing of this.timings) {
        let rec = this.timings.filter(
          (c) =>
            c.TimezoneId == timing.TimezoneId &&
            c.Hour == timing.Hour &&
            c.Minute == timing.Minute &&
            c.TimePart == timing.TimePart
        );
        if (rec.length > 1) {
          this.$swal("Duplicate class time detected", { icon: "error" });
          return;
        }
      }
      //check for overlap timing
      let totalDuration =
        (this.durationHour ? parseInt(this.durationHour) : 0) * 60 +
        (this.durationMinute ? parseInt(this.durationMinute) : 0);
      for (let i = 0; i < this.timings.length; i++) {
        let timing1 = this.timings[i];
        let timezoneId1 = timing1.TimezoneId;
        let totalTimeMinutesStart1 =
          (timing1.TimePart == "AM"
            ? parseInt(timing1.Hour) == 12
              ? 0
              : parseInt(timing1.Hour)
            : parseInt(timing1.Hour) < 12
            ? parseInt(timing1.Hour) + 12
            : 12) *
            60 +
          parseInt(timing1.Minute);
        let totalTimeMinutesEnd1 = totalTimeMinutesStart1 + totalDuration;
        for (let j = i + 1; j < this.timings.length; j++) {
          let timing2 = this.timings[j];
          let timezoneId2 = timing2.TimezoneId;
          let totalTimeMinutesStart2 =
            (timing2.TimePart == "AM"
              ? parseInt(timing2.Hour) == 12
                ? 0
                : parseInt(timing2.Hour)
              : parseInt(timing2.Hour) < 12
              ? parseInt(timing2.Hour) + 12
              : 12) *
              60 +
            parseInt(timing2.Minute);
          let totalTimeMinutesEnd2 = totalTimeMinutesStart2 + totalDuration;
          if (
            timezoneId2 == timezoneId1 &&
            ((totalTimeMinutesStart2 >= totalTimeMinutesStart1 &&
              totalTimeMinutesStart2 < totalTimeMinutesEnd1) ||
              (totalTimeMinutesEnd2 > totalTimeMinutesStart1 &&
                totalTimeMinutesEnd2 <= totalTimeMinutesEnd1))
          ) {
            this.$swal("Overlapping class time detected", { icon: "error" });
            return;
          }
        }
      }

      let selectedSchoolAddresses = [];
      if (this.showLocationSchoolAddress) {
        selectedSchoolAddresses = this.schoolAddresses.filter(
          (c) => c.IsSelected == true
        );
        if (selectedSchoolAddresses.length == 0) {
          this.$swal("Please select at least 1 school address", {
            icon: "error",
          });
          return;
        }
      }
      let selectedInstructors = this.instructors.filter(
        (c) => c.IsSelected == true
      );
      if (selectedInstructors.length == 0) {
        this.$swal("Please add at least 1 instructor", { icon: "error" });
        return;
      }
      if (this.showCustomFrequency) {
        if (this.customFrequency == "Weekly") {
          if (this.customWeeklyFrequencyOn.length == 0) {
            this.$swal(
              "Please select at least 1 day for the weekly frequency",
              {
                icon: "error",
              }
            );
            return;
          }
        } else if (this.customFrequency == "Monthly") {
          if (
            this.customMonthlyFrequencyType == "each" &&
            this.customMonthlyFrequencyEach.length == 0
          ) {
            this.$swal(
              "Please select at least 1 date for the monthly frequency",
              {
                icon: "error",
              }
            );
            return;
          }
        } else if (this.customFrequency == "Yearly") {
          if (this.customYearlyFrequencyIn.length == 0) {
            this.$swal(
              "Please select at least 1 month for the yearly frequency",
              {
                icon: "error",
              }
            );
            return;
          }
        }
      }
      let param = {
        Token: this.tokenObj.Token,
        Id: this.$route.params.id,
        SchoolId:
          this.tokenObj.UserType == this.userTypeMainAdmin
            ? this.schoolId
            : this.tokenObj.SchoolId,
        SubjectId: this.subjectId,
        SubjectLevelId: this.subjectLevelId,
        ShowSubjectLevelOthers: this.showSubjectLevelOthers,
        SubjectLevelOthers: this.subjectLevelOthers,
        DurationHour: this.durationHour,
        DurationMinute: this.durationMinute,
        FrequencyId: this.frequencyId,
        ShowCustomFrequency: this.showCustomFrequency,
        CustomFrequency: this.customFrequency,
        CustomDailyFrequencyEvery: this.customDailyFrequencyEvery,
        CustomWeeklyFrequencyEvery: this.customWeeklyFrequencyEvery,
        CustomWeeklyFrequencyOn: this.customWeeklyFrequencyOn.join(),
        CustomMonthlyFrequencyEvery: this.customMonthlyFrequencyEvery,
        CustomMonthlyFrequencyEach: this.customMonthlyFrequencyEach.join(),
        CustomMonthlyFrequencyType: this.customMonthlyFrequencyType,
        CustomMonthlyFrequencyOnOrder: this.customMonthlyFrequencyOnOrder,
        CustomMonthlyFrequencyOnPeriod: this.customMonthlyFrequencyOnPeriod,
        CustomYearlyFrequencyEvery: this.customYearlyFrequencyEvery,
        CustomYearlyFrequencyIn: this.customYearlyFrequencyIn.join(),
        IsCustomYearlyFrequencyOn: this.isCustomYearlyFrequencyOn,
        CustomYearlyFrequencyOnOrder: this.customYearlyFrequencyOnOrder,
        CustomYearlyFrequencyOnPeriod: this.customYearlyFrequencyOnPeriod,
        CommencementDateInput: this.commencementDate,
        Timings: this.timings,
        LocationId: this.locationId,
        ShowLocationSchoolAddress: this.showLocationSchoolAddress,
        SchoolAddresses: selectedSchoolAddresses,
        ShowLocationOthers: this.showLocationOthers,
        LocationOthers: this.locationOthers,
        Instructors: selectedInstructors,
      };
      API.class
        .validateSaveClass(param)
        .then((response) => {
          if (response.data.success) this.saveClass();
          this.$swal(response.data.message, { icon: "error" });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveClass() {
      let selectedSchoolAddresses = [];
      if (this.showLocationSchoolAddress) {
        selectedSchoolAddresses = this.schoolAddresses.filter(
          (c) => c.IsSelected == true
        );
      }
      let selectedInstructors = this.instructors.filter(
        (c) => c.IsSelected == true
      );
      let param = {
        Token: this.tokenObj.Token,
        Id: this.$route.params.id,
        SchoolId:
          this.tokenObj.UserType == this.userTypeMainAdmin
            ? this.schoolId
            : this.tokenObj.SchoolId,
        SubjectId: this.subjectId,
        SubjectLevelId: this.subjectLevelId,
        ShowSubjectLevelOthers: this.showSubjectLevelOthers,
        SubjectLevelOthers: this.subjectLevelOthers,
        DurationHour: this.durationHour,
        DurationMinute: this.durationMinute,
        CurrencyId: this.currencyId,
        Amount: this.amount,
        IsInclusiveTax: this.isInclusiveTax,
        FrequencyId: this.frequencyId,
        ShowCustomFrequency: this.showCustomFrequency,
        CustomFrequency: this.customFrequency,
        CustomDailyFrequencyEvery: this.customDailyFrequencyEvery,
        CustomWeeklyFrequencyEvery: this.customWeeklyFrequencyEvery,
        CustomWeeklyFrequencyOn: this.customWeeklyFrequencyOn.join(),
        CustomMonthlyFrequencyEvery: this.customMonthlyFrequencyEvery,
        CustomMonthlyFrequencyEach: this.customMonthlyFrequencyEach.join(),
        CustomMonthlyFrequencyType: this.customMonthlyFrequencyType,
        CustomMonthlyFrequencyOnOrder: this.customMonthlyFrequencyOnOrder,
        CustomMonthlyFrequencyOnPeriod: this.customMonthlyFrequencyOnPeriod,
        CustomYearlyFrequencyEvery: this.customYearlyFrequencyEvery,
        CustomYearlyFrequencyIn: this.customYearlyFrequencyIn.join(),
        IsCustomYearlyFrequencyOn: this.isCustomYearlyFrequencyOn,
        CustomYearlyFrequencyOnOrder: this.customYearlyFrequencyOnOrder,
        CustomYearlyFrequencyOnPeriod: this.customYearlyFrequencyOnPeriod,
        CommencementDateInput: this.commencementDate,
        Timings: this.timings,
        LocationId: this.locationId,
        ShowLocationSchoolAddress: this.showLocationSchoolAddress,
        SchoolAddresses: selectedSchoolAddresses,
        ShowLocationOthers: this.showLocationOthers,
        LocationOthers: this.locationOthers,
        Instructors: selectedInstructors,
        Remarks: this.remarks,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to save the class?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.class
            .saveClass(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success)
                this.$router.replace({
                  name:
                    this.tokenObj.UserType == this.userTypeMainAdmin
                      ? "mainAdminClassList"
                      : "schoolAdminClassList",
                });
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    getClassDetail() {
      let param = {
        Token: this.tokenObj.Token,
        Id: this.$route.params.id,
      };
      this.$store.state.isLoading = true;
      API.class
        .getClassDetail(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            let data = response.data.data;
            this.schoolId = data.SchoolId;
            this.getSubjectsForClass(data.SchoolId);
            this.getSubjectLevelsForClass(data.SchoolId);
            this.getSchoolSalesTax(data.SchoolId);
            this.subjectId = data.SubjectId;
            this.subjectLevelId = data.SubjectLevelId;
            this.durationHour = data.DurationHour;
            this.durationMinute = data.DurationMinute;
            this.isInclusiveTax = data.IsInclusiveTax;
            this.currencyId = data.CurrencyId;
            this.amount = data.Amount;
            this.frequencyId = data.FrequencyId;
            this.showCustomFrequency = data.ShowCustomFrequency;
            this.customFrequency = !data.CustomFrequency
              ? ""
              : data.CustomFrequency;
            if (data.CustomFrequency == "Daily") {
              this.customDailyFrequencyEvery = data.CustomDailyFrequencyEvery;
            } else if (data.CustomFrequency == "Weekly") {
              this.customWeeklyFrequencyEvery = data.CustomWeeklyFrequencyEvery;
              this.customWeeklyFrequencyOn =
                data.CustomWeeklyFrequencyOn.split(",");
            } else if (data.CustomFrequency == "Monthly") {
              this.customMonthlyFrequencyEvery =
                data.CustomMonthlyFrequencyEvery;
              this.customMonthlyFrequencyType = data.CustomMonthlyFrequencyType;
              if (data.CustomMonthlyFrequencyType == "each") {
                this.customMonthlyFrequencyEach =
                  data.CustomMonthlyFrequencyEach.split(",").map(Number);
              } else if (data.CustomMonthlyFrequencyType == "on") {
                this.customMonthlyFrequencyOnOrder =
                  data.CustomMonthlyFrequencyOnOrder;
                this.customMonthlyFrequencyOnPeriod =
                  data.CustomMonthlyFrequencyOnPeriod;
              }
            } else if (data.CustomFrequency == "Yearly") {
              this.customYearlyFrequencyEvery = data.CustomYearlyFrequencyEvery;
              this.customYearlyFrequencyIn =
                data.CustomYearlyFrequencyIn.split(",");
              this.isCustomYearlyFrequencyOn = data.IsCustomYearlyFrequencyOn;
              if (data.IsCustomYearlyFrequencyOn == true) {
                this.customYearlyFrequencyOnOrder =
                  data.CustomYearlyFrequencyOnOrder;
                this.customYearlyFrequencyOnPeriod =
                  data.CustomYearlyFrequencyOnPeriod;
              }
            }
            this.commencementDate = data.CommencementDateCal;
            this.timings = data.Timings;
            this.locationId = data.LocationId;
            this.showLocationOthers = data.ShowLocationOthers;
            this.locationOthers = data.LocationOthers;
            this.showLocationSchoolAddress = data.ShowLocationSchoolAddress;
            this.schoolAddresses = data.SchoolAddresses;
            this.checkAllSchoolAddresses =
              data.SchoolAddresses.length ==
              data.SchoolAddresses.filter((c) => c.IsSelected == true).length;
            this.instructors = data.Instructors;
            this.checkAllInstructors =
              data.Instructors.length ==
              data.Instructors.filter((c) => c.IsSelected == true).length;
            this.remarks = data.Remarks;
          } else {
            this.$store.state.isLoading = false;
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    addClassBooking() {
      this.$store.state.class.classId = this.$route.params.id;
      if (this.isInstructor) {
        this.$router.push({ name: "instructorClassBookingAdd" });
      } else if (this.isStudent) {
        this.$router.push({ name: "studentClassBookingForm" });
      } else {
        this.$router.push({
          name:
            this.tokenObj.UserType == this.userTypeMainAdmin
              ? "mainAdminClassBookingAdd"
              : "schoolAdminClassBookingAdd",
        });
      }
    },
  },
  created() {
    this.getSchools();
    this.getCurrencies();
    this.getClassFrequencies();
    this.getClassLocations();
    this.getTimezones();
    if (this.$route.params.id) this.getClassDetail();
    if (!this.$route.params.id) {
      if (this.tokenObj.UserType != this.userTypeMainAdmin) {
        this.getSubjectsForClass(this.tokenObj.SchoolId);
        this.getSubjectLevelsForClass(this.tokenObj.SchoolId);
        this.getSchoolSalesTax(this.tokenObj.SchoolId);
        this.getSchoolAddresses(this.tokenObj.SchoolId);
        this.getSchoolInstructors(this.tokenObj.SchoolId);
      }
    }
  },
};
</script>

<style scoped>
.fit-content {
  max-width: fit-content;
}

.customdaily-input,
.customweekly-input,
.custommonthly-input,
.customyearly-input {
  width: 80px;
}

.week_options,
.month_options,
.year_options {
  position: absolute;
  z-index: 20;
  left: -1000px;
}

.bg-grey {
  background-color: lightgrey;
}

.custtomweekly-div,
.custommonthly-div,
.customyearly-div {
  word-spacing: -9px;
}
.custtomweekly-div label {
  cursor: pointer;
  width: 50px;
  height: 50px;
  border: 1px solid darkgray;
  text-align: center;
  vertical-align: middle;
  padding-top: 13px;
}

.custommonthly-cal label {
  cursor: pointer;
  width: 35px;
  height: 35px;
  border: 1px solid darkgray;
  text-align: center;
  vertical-align: middle;
  padding-top: 6px;
  margin: 0;
}

.customyearly-cal label {
  cursor: pointer;
  width: 52px;
  height: 52px;
  border: 1px solid darkgray;
  text-align: center;
  vertical-align: middle;
  padding-top: 12px;
  margin: 0;
}

input[type="checkbox"],
input[type="radio"] {
  cursor: pointer;
}

.table-responsive,
.table {
  margin-bottom: 0;
}
.no-col {
  width: 40px;
  vertical-align: middle;
}
.timezone-col {
  width: 35%;
}
.time-col {
  width: 30%;
}

.instructor-table td {
  padding-top: 0;
  padding-bottom: 0;
  border-top: none;
  border-left: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
}
.instructor-table tr:last-child td {
  border-bottom: 1px solid #dee2e6;
}
.my-custom-swal {
  width: auto !important;
  max-width: fit-content !important;
}

@media only screen and (max-width: 767.98px) {
  .custtomweekly-div,
  .custommonthly-div,
  .custommonthly-div-on,
  .customyearly-div,
  .customyearly-div-on {
    margin-top: 10px !important;
  }
  .w-xs-40 {
    width: 40% !important;
  }
  .w-xs-50 {
    width: 50% !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SchoolUser/SchoolAdmin/ClassEdit.vue